import { useToast } from '@chakra-ui/react';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { useMutation, useQuery } from '@tanstack/react-query';
import { T_THFormHandlerProps } from './formHandlerPropsType';
import OutgoingSummaryDetailsFormMeta from './OutgoingSummaryDetailsFormMeta';
import GenericFormUI from "@Shared/components/form/GenericFormUI";
import PresentmentDataTableHandler from "./presentment/PresentmentDataTableHandler";
import RepresentmentDataTableHandler from "./representment/RepresentmentDataTableHandler";
import FirstChargebackDataTableHandler from "./firstChargeback/FirstChargebackDataTableHandler";
import FeesDataTableHandler from "./fees/FeesDataTableHandler";
import RequestConfirmationDataTableHandler from "./requestConfirmation/RequestConfirmationDataTableHandler";
import MessageDataTableHandler from "./message/MessageDataTableHandler";
import FraudDataTableHandler from "./fraud/FraudDataTableHandler";

const OutgoingSummaryDetailsFormHandler: React.FC<T_THFormHandlerProps> = ({id}) => {
    
  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = ["EMV Data"];
  const {
    isLoading,
  } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
        // TODO: Replace this by your fetcher function
        return new Promise(function(resolve) {
            setTimeout(() => resolve("data"), 500);
        });
    },
    onSuccess: (data_: any) => {
       //console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title: "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const { isLoading: isSubmitting } = useMutation( async() => {}, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        position: 'top-right',
        title: "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    /*try {
         await mutateAsync();
     } catch (error) {
         console.log(error);
     }*/
  };

  return <>
    
    <GenericFormUI
      meta={OutgoingSummaryDetailsFormMeta}
      onSubmit={onSubmit}
      isLoading={isLoading}
      isSubmitting={isSubmitting}
      submitBtn={<></>}
      mb={4}
    />

    <CC.Tabs>
        <div style={{overflow: 'auto'}}>
          <CC.TabList>
            <CC.Tab minWidth={'fit-content'}>Presentment</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Representment</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>1st chargeback</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Fees</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Request/Confirmation</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Message</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Fraud</CC.Tab>
          </CC.TabList>
        </div>

        <CC.TabPanels>
          <CC.TabPanel>
            <PresentmentDataTableHandler />
          </CC.TabPanel>
          <CC.TabPanel>
            <RepresentmentDataTableHandler />
          </CC.TabPanel>
          <CC.TabPanel>
            <FirstChargebackDataTableHandler />
          </CC.TabPanel>
          <CC.TabPanel>
            <FeesDataTableHandler />
          </CC.TabPanel>
          <CC.TabPanel>
            <RequestConfirmationDataTableHandler />
          </CC.TabPanel>
          <CC.TabPanel>
            <MessageDataTableHandler />
          </CC.TabPanel>
          <CC.TabPanel>
            <FraudDataTableHandler />
          </CC.TabPanel>
        </CC.TabPanels>
    </CC.Tabs>
  </>;
};

export default OutgoingSummaryDetailsFormHandler;
